(function() {
'use strict';

angular
    .module('TR')
    .controller('FlightsSort', FlightsSort);

function FlightsSort($scope, flightSearch, preferences) {
    const fs = this;

    preferences.getFlightSortOrder().then(function(so) {
        fs.SortCriterion = so;

        $scope.$watch('fs.SortCriterion', function(f, o) {
            if (f == null || f === o) {
                return;
            }
            flightSearch.sort(f);
        }, true);
    });
 }
})();
